import { render, staticRenderFns } from "./EditBadges.vue?vue&type=template&id=3b24ee7e&scoped=true"
import script from "./EditBadges.ts?vue&type=script&lang=ts&external"
export * from "./EditBadges.ts?vue&type=script&lang=ts&external"
import style0 from "./EditBadges.vue?vue&type=style&index=0&id=3b24ee7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b24ee7e",
  null
  
)

export default component.exports